module.exports = __webpack_public_path__ + "static/media/shicechi.f6e08466.png";